export const DEFAULT_WEB_GATEWAY_ENDPOINT = "http://127.0.0.1:3721";

export interface WebGatewayTarget {
    endpoint: string;
    explicit: boolean;
}

function normalizeEndpoint(endpoint: string): string {
    return endpoint.startsWith("http") ? endpoint : `http://${endpoint}`;
}

export function resolveWebGatewayTarget(
    search: string,
    defaultEndpoint = DEFAULT_WEB_GATEWAY_ENDPOINT,
): WebGatewayTarget {
    const gatewayParam = new URLSearchParams(search).get("gateway");
    if (gatewayParam) {
        return {
            endpoint: normalizeEndpoint(gatewayParam),
            explicit: true,
        };
    }

    return {
        endpoint: normalizeEndpoint(defaultEndpoint),
        explicit: false,
    };
}
